var React = require('react');

function H3 (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"H3"),React.createElement("g",{"style":{"isolation":"isolate"},"key":1},[React.createElement("polygon",{"points":"48.17 0.47 45.67 29.11 26.9 27.34 17.99 46.74 44.1 49.13 41.51 80.22 64.5 82.14 71.17 2.39 48.17 0.47","fill":"#f47643","style":{"mixBlendMode":"multiply"},"key":0}),React.createElement("g",{"style":{"mixBlendMode":"multiply"},"key":1},React.createElement("rect",{"x":"0.89","y":"0.25","width":"23.07","height":"80.03","transform":"translate(0.91 -0.27) rotate(1.29)","fill":"#73c9bd"}))])]);
}

H3.defaultProps = {"viewBox":"0 0 71.16 82.14"};

module.exports = H3;

H3.default = H3;
